export default () => 'web'
